// navigation.js - Módulo para la funcionalidad de navegación

// Exportar funciones principales
export function toggleMobileMenu() {
  const mobileMenu = document.getElementById("mobile-menu");
  mobileMenu.classList.toggle("hidden");
}

export function toggleMobileTours() {
  const mobileToursDropdown = document.getElementById("mobile-tours-dropdown");
  const mobileToursArrow = document.getElementById("mobile-tours-arrow");

  mobileToursDropdown.classList.toggle("hidden");
  mobileToursArrow.classList.toggle("rotate-180");
}

// Función para cerrar menús al hacer clic fuera
export function closeMenusOnClickOutside() {
  document.addEventListener("click", function (event) {
    const mobileMenu = document.getElementById("mobile-menu");
    const mobileMenuButton = document.getElementById("mobile-menu-button");
    const mobileToursDropdown = document.getElementById(
      "mobile-tours-dropdown"
    );
    const mobileToursButton = document.getElementById("mobile-tours-button");
    const mobileToursArrow = document.getElementById("mobile-tours-arrow"); // <-- Agrega esta línea

    // Cerrar menú móvil si se hace clic fuera
    if (
      mobileMenu &&
      !mobileMenu.contains(event.target) &&
      mobileMenuButton &&
      !mobileMenuButton.contains(event.target)
    ) {
      mobileMenu.classList.add("hidden");
    }

    // Cerrar dropdown de tours móvil si se hace clic fuera
    if (
      mobileToursDropdown &&
      !mobileToursDropdown.contains(event.target) &&
      mobileToursButton &&
      !mobileToursButton.contains(event.target)
    ) {
      mobileToursDropdown.classList.add("hidden");
      if (mobileToursArrow) {
        mobileToursArrow.classList.remove("rotate-180");
      }
    }
  });
}

// Función para inicializar todos los event listeners
export function initializeNavigation() {
  const mobileMenuButton = document.getElementById("mobile-menu-button");
  const mobileToursButton = document.getElementById("mobile-tours-button");

  if (mobileMenuButton) {
    mobileMenuButton.addEventListener("click", toggleMobileMenu);
  }

  if (mobileToursButton) {
    mobileToursButton.addEventListener("click", toggleMobileTours);
  }

  closeMenusOnClickOutside();

  console.log("Navigation module initialized successfully");
}

// Inicializar automáticamente cuando se carga el módulo
initializeNavigation();
